<template>
    <div>
        <label><input type="checkbox" v-model="block.showInNavigation" ref="showInNavigation"> In Navigation anzeigen</label>
        <text-input v-model="block.name" label="Name" ref="name" />
        <file-input v-model="block.images" label="Bilder" type="image" :max-files="12"/>
        <button class="btn btn-primary" @click="save">Save</button>
    </div>
</template>
<script>
export default {
  props: ["project", "blockData"],
  data() {
    return {
      block: this.blockData
    };
  },
  methods: {
    save() {
      let form = new FormData();
      for (let i = 0; i < this.block.images.length; i++) {
        form.append(
          "edit_image_gallery_block[images][" + i + "]",
          this.block.images[i].id
        );
      }
      if (this.block.showInNavigation)
        form.append(
          "edit_image_gallery_block[showInNavigation]",
          this.block.showInNavigation
        );
      form.append("edit_image_gallery_block[submit]", 1);

      Promise.all([
        this.$refs.name.save(),
        axios.post(
          "/api/" + store.state.language + "/block/" + this.block.id + "/edit",
          form
        )
      ]).then(() => {console.log("foo")});
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Blocks/ImageGalleryBlock.vue